import React, { useState } from 'react';
import '../../styles/explore.scss';

function FaqAccordion({ items }) {
	const [openIndex, setOpenIndex] = useState(0);

	if (!items || items.length === 0) return null;

	return (
		<div className="faq-list">
			{items.map((item, i) => (
				<div key={item.q} className="faq-item">
					<button
						type="button"
						className={`faq-item__question${openIndex === i ? ' is-open' : ''}`}
						onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
						aria-expanded={openIndex === i}
					>
						{item.q}
					</button>
					{openIndex === i && <div className="faq-item__answer">{item.a}</div>}
				</div>
			))}
		</div>
	);
}

export default FaqAccordion;
